import styled from 'styled-components';

import { BasicSubtitle } from '@genially/design-system';
import DragAndDropHandIcon from '@genially/icons/lib/dragAndDropHand/DragAndDropHandIcon';

export const StyledDragAndDropHandIcon = styled(DragAndDropHandIcon)(
  ({ theme: { color, transition } }) => ({
    color: color.content.reversed.default(),
    transition: transition.standard('color'),
  }),
);

interface RaiseHandButtonProps {
  $active: boolean;
}

export const RaiseHandContainer = styled.button<RaiseHandButtonProps>(
  ({ theme: { size, color, transition }, $active }) => ({
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: size.units(0.5),
    minWidth: size.units(7),
    height: size.units(7),
    borderRadius: size.units(7),
    fontSize: size.units(3),
    backgroundColor: $active ? color.background.graphics(7, 0.88) : 'rgba(0, 0, 0, 0.5)',
    padding: `${size.units(1)} ${size.units(2)}`,
    outline: $active
      ? `2px solid ${color.border.success.contrast()}`
      : '2px solid transparent',
    outlineOffset: size.units(-0.25),
    transition: transition.standard('background-color', 'outline-color', 'transform'),
    cursor: 'pointer',
    WebkitTapHighlightColor: 'transparent',

    userSelect: 'none',

    '&:active': {
      transform: 'scale(1.3)',
    },

    '&:hover': {
      outline: `2px solid ${color.border.success.default()}`,
      backgroundColor: color.background.graphics(7),

      [StyledDragAndDropHandIcon]: {
        color: color.content.success.default(),
      },
    },

    ...($active && {
      [StyledDragAndDropHandIcon]: {
        color: color.content.success.contrast(),
      },
    }),
  }),
);

export const StyledBasicSubtitle = styled(BasicSubtitle)(({ theme: { color } }) => ({
  color: color.content.success.contrast(),
}));
